import React, {Component} from 'react';
import {EmailIcon, FacebookShareButton, LinkedinShareButton, RedditShareButton, TwitterShareButton, TwitterIcon, FacebookIcon, LinkedinIcon, RedditIcon} from "react-share";

class SocialMediaButtons extends  Component {
    render() {
        return (
            <div className="footerShareGrid">
                <div className="socialMediaButton" id="twitterButton">
                    <TwitterShareButton
                        url={"apispreadsheets.com"}
                        title={"I saved so much time with apispreadsheets.com! Check it out if you need an easy solution to convert your spreadsheet to a REST API. "} >
                        <TwitterIcon
                            size={32}
                            round />
                    </TwitterShareButton>
                </div>
                <div className="socialMediaButton" id="facebookButton">
                    <FacebookShareButton
                        url={"apispreadsheets.com"}
                        title={"I saved so much time with apispreadsheets.com! Check it out if you need an easy solution to convert your spreadsheet to a REST API. "} >
                        <FacebookIcon
                            size={32}
                            round />
                    </FacebookShareButton>
                </div>
                <div className="socialMediaButton" id="redditButton">
                    <RedditShareButton
                        url={"apispreadsheets.com"}
                        title={"I saved so much time with apispreadsheets.com! Check it out if you need an easy solution to convert your spreadsheet to a REST API. "} >
                        <RedditIcon
                            size={32}
                            round />
                    </RedditShareButton>
                </div>
                <div className="socialMediaButton" id="linkedinButton">
                    <LinkedinShareButton
                        url={"apispreadsheets.com"}
                        title={"I saved so much time with apispreadsheets.com! Check it out if you need an easy solution to convert your spreadsheet to a REST API. "} >
                        <LinkedinIcon
                            size={32}
                            round />
                    </LinkedinShareButton>
                </div>
                <div className="socialMediaButton" id="emailButton">
                    <a href="mailto:info@apispreadsheets.com?Subject=I%20Want%20To%20Convert%20Spreadsheets%20to%20API">
                        <EmailIcon size={32} round />
                    </a>
                </div>
                <div>

                </div>
            </div>
        );
    }
}


export default SocialMediaButtons